import "../../../styles/switch.scss";

import PropTypes from "prop-types";
import React from "react";

class Switch extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        if (this.props.disabled) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (this.props.onChange) {
            this.props.onChange(!this.props.checked);
        }
    }

    render() {
        const {
            checked,
            disabled,
            checkedLabel,
            uncheckedLabel
        } = this.props;

        return (
            <div className="switch-wrapper">
                <div className={`switch ${checked ? "checked" : "unchecked"}${disabled ? " disabled" : ""}`} onClick={this.onClick}>
                    <div className="switch-icon">
                        <div className="switch-outset">
                            <div className="switch-box">
                                <div className="switch-tick"></div>
                            </div>
                        </div>
                    </div>
                    {((checked && checkedLabel) || (!checked && uncheckedLabel)) && (
                        <div className="switch-label">
                            {checked ? checkedLabel : uncheckedLabel}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Switch.propTypes = {
    checked: PropTypes.bool,
    checkedLabel: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    uncheckedLabel: PropTypes.string
};

export default Switch;